<template>
  <div id="print">

    <div class="book m-auto">

      <div
        v-for="(data, idx) in Math.ceil(goodsissue.orders.length/maxOrderLists)"
        :key="idx"
        :style="`font-size: ${fontSize}%;`"
        class="page">
        <div class="subpage">
          <div
            class="top-header"
            style="padding: 0 0 30px 0;">
            <div
              v-if="idx == 0"
              class="company-info">
              <img
                v-if="shopInfo.logo.thumbnail"
                :src="shopInfo.logo.thumbnail">
              <div class="name">
                <strong class="text-black">{{ shopInfo.shop_name }}</strong>
                <p>{{ shopInfo.info.location.address }}</p>
              </div>
            </div>
            <div class="document-type">
              <h2 class="text-black">{{ $t('documents.gi') }}</h2>
              <p>{{ goodsissue.gi_code }}</p>
            </div>
          </div>
          <div
            v-if="idx == 0"
            class="content">
            <div class="left">
              <div class="section">
                <p class="label">{{ $t('message.customer') }}</p>
                <p class="detail">{{ goodsissue.customer.customer_name }}</p>
              </div>
              <div
                v-if="getPartnerContact(goodsissue.customer.contacts).tel"
                class="section">
                <p class="label">{{ $t('message.tel') }}</p>
                <p class="detail">{{ getPartnerContact(goodsissue.customer.contacts).tel }}</p>
              </div>
              <div
                v-if="goodsissue.customer.address"
                class="section">
                <p class="label">{{ $t('message.address') }}</p>
                <p class="detail">{{ goodsissue.customer.address }}</p>
              </div>
            </div>
            <div class="right">
              <div class="section">
                <p class="label">{{ $t('apps.inventory.message.deliverydate') }}</p>
                <p class="detail">{{ getDateTime(goodsissue.scheduled_at) }}</p>
              </div>
              <div class="section">
                <p class="label">{{ $t('apps.inventory.message.postingatdeliveredorders') }}</p>
                <p class="detail">
                  {{ goodsissue.posting_at ? getDateTime(goodsissue.posting_at) : '-' }}
                </p>
              </div>
            </div>
          </div>
          <div class="order">
            <table>
              <thead>
                <tr>
                  <td width="10px"><b>#</b></td>
                  <td width="40%"><b>{{ $t('message.description') }}</b></td>
                  <td v-if="showBinColumn"><b>{{ $t('apps.inventory.label.bin') }}</b></td>
                  <td class="text-right"><b>{{ $t('message.quantity') }}</b></td>
                  <td class="text-right"><b>{{ $t('status.gi.done') }}</b></td>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="({ item, quantity, done, bin_location_id }, idx_) in groupOrders[idx].orders"
                  :key="idx_">
                  <td width="10px"><b>{{ (maxOrderLists*idx)+(idx_+1) }}</b></td>
                  <td width="40%">{{ item }}</td>
                  <td v-if="showBinColumn">{{ getBinNameBy(bin_location_id) }}</td>
                  <td class="text-right">{{ getNumber(quantity) }}</td>
                  <td class="text-right">{{ getNumber(done) }}</td>
                </tr>
              </tbody>
            </table>
          </div>

          <div
            v-if="Math.ceil(goodsissue.orders.length/maxOrderLists) > 0 && idx !== (Math.ceil(goodsissue.orders.length/maxOrderLists)-1)"
            class="next-page">
            {{ $t('message.havenextpage') }}
          </div>

          <div
            v-if="idx >= (Math.ceil(goodsissue.orders.length/maxOrderLists)-1)"
            class="footer">

            <div class="note">
              <div
                v-if="goodsissue.note"
                class="section">
                <p>{{ $t('message.note') }}</p>
                <p style="white-space: pre;word-wrap: break-word; overflow-wrap: break-word; white-space: normal;">{{ goodsissue.note }}</p>
              </div>
            </div>

            <div class="total">

              <div class="section">

                <div class="section row m-0">
                  <div class="label">
                    {{ $t('apps.inventory.message.pickfrom') }}
                  </div>
                  <div class="detail text-right">
                    <span class="text-underline-border">{{ warehouseName }}</span>
                  </div>
                </div>

              </div>

            </div>

            <div :class="['signature', { 'non-fixed-bottom': !isFixedSignatureBottom }]">
              <div class="left">
                <div class="title max-line-1">
                  {{ goodsissue.customer.customer_name }}
                </div>
                <div class="info">
                  <div class="name">
                    {{ $t('message.name') }}
                  </div>
                  <div class="date">
                    {{ $t('message.date') }}
                  </div>
                </div>
              </div>
              <div class="right">
                <div class="title max-line-1">
                  {{ shopInfo.shop_name }}
                </div>
                <div class="info">
                  <div class="name">
                    {{ $t('message.name') }}
                  </div>
                  <div class="date">
                    {{ $t('message.date') }}
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>

    </div>

  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

import _ from 'lodash'

export default {
  props: {
    goodsissue: {
      type: Object,
    },
    fontSize: {
      type: Number,
      default: 100,
    },
    isFixedSignatureBottom: {
      type: Boolean,
      default: true,
    },
  },
  data () {
    return {
      maxOrderLists: 15,
    }
  },
  computed: {
    ...mapGetters({
      shopInfo: 'getShopInfo',
      getPartnerContact: 'getPartnerContact',
      getWarehouseInfo: 'getWarehouseInfo',
      getBinNameBy: 'getBinNameBy',
    }),
    groupOrders () {
      var results = []
      var currentIdx = 0

      for (let i = 0; i < Math.ceil(this.goodsissue.orders.length / this.maxOrderLists); i++) {
        var page = i + 1
        results.push({
          'page': page,
          'orders': [],
        })
      }

      for (let i = 0; i < this.goodsissue.orders.length; i++) {
        let order = this.goodsissue.orders[i]

        if (i % (this.maxOrderLists) == 0 && i !== 0) {
          currentIdx++
        }

        results[currentIdx].orders.push(order)
      }

      return results
    },
    warehouseName () {
      return this.getWarehouseInfo(this.goodsissue.stockout.warehouse_id).warehouse_name
    },
    showBinColumn() {
      return this.goodsissue.orders.reduce((acc, cur) => {
        if (cur.bin_location_id != null) {
          acc = true
        }
        return acc
      }, false)
    },
  },
}
</script>

<style scoped>
  @page {
      size: A4;
      margin: 0;
  }

  @media print {
      #print .page {
          margin: 0;
          border: initial;
          border-radius: initial;
          width: initial;
          min-height: initial;
          box-shadow: initial;
          background: initial;
          page-break-after: always;
      }
  }
</style>



// WEBPACK FOOTER //
// src/components/apps/inventory/goodsissue/include/PrintGi.vue